import Slide from '@/components/shared/Slide';
import { PROVIDER_BRAND } from '@/data/provider-brand';
import type { RoadmapCompanyConfig, ViewMode } from '@/types/roadmap.types';

interface Props {
  config: RoadmapCompanyConfig;
  mode: ViewMode;
}

export default function CoverSlide({ config, mode }: Props) {
  const { company, proposal, clientBrand } = config;
  return (
    <Slide mode={mode} className="items-center print:border-0">
      <div className="w-full text-center print:border-0">
        {clientBrand?.logo && (
          <div className="mb-8">
            <img
              src={clientBrand.logo}
              alt={clientBrand.companyName}
              className="h-14 mx-auto"
            />
          </div>
        )}
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-6 print:text-[10pt] print:mb-5">
          Funding Roadmap
        </p>
        <h1 className="text-6xl sm:text-7xl lg:text-8xl font-extrabold tracking-tight text-foreground mb-6 print:text-[32pt] print:leading-tight print:mb-5">
          {company.name}
        </h1>

        <p className="text-sm text-muted-foreground mb-8 print:text-[11pt] print:mb-6">
          Version {proposal.version} &middot;{' '}
          {new Date(proposal.created_at).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </p>

        <div className="flex items-center justify-center gap-2">
          <img
            src={PROVIDER_BRAND.logo}
            alt={PROVIDER_BRAND.companyName}
            className="h-5"
          />
        </div>
      </div>
    </Slide>
  );
}
